// version generated from package.json and git tag distance
import versionCode from "../version";

export const getAppVersion = serverVersion => ( serverVersion ? `${ versionCode }; ${ serverVersion }` : versionCode );
